import { FieldTypeAsset } from '@allesauto/utils/consts';
import { isVideo } from '@allesauto/utils/funcs';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React from 'react';

import IframeWithConsent from '../iframeWithConsent';

export interface ISimpleVideoComponent {
  title: string;
  link: FieldTypeAsset;
  withPadding?: boolean;
  component: string;
  _uid: string;
  _editable?: string;
}

const SimpleVideoComponent: React.FC<ISimpleVideoComponent> = (props) => {
  const { link, title, withPadding = false } = props;

  const url = link?.filename ?? null;

  return (
    <div
      {...sbEditable(props)}
      className={clsx(
        'grid grid-cols-24 relative',
        withPadding && 'sm:pt-10px md:pt-20px md:pb-10px'
      )}
    >
      <div className="aspect-video flex flex-row relative sm:col-end-24 sm:col-start-2 md:col-end-24 md:col-start-2">
        {url && isVideo(url) ? (
          <video width="100%" height="100%" title={title} controls>
            <source src={url} />
          </video>
        ) : (
          url && <IframeWithConsent url={url} title={title} />
        )}
      </div>
    </div>
  );
};

export default SimpleVideoComponent;
